import script from "./task-mgmt-list.vue?vue&type=script&lang=tsx&setup=true"
export * from "./task-mgmt-list.vue?vue&type=script&lang=tsx&setup=true"

const __exports__ = script;

export default __exports__